/**
 * @file index.tsx
 *
 * @fileoverview Renders a bottom navigation menu for mobile.
 */
import React from "react";
import styles from "./bottomMenu.module.scss";

export interface BottomMenuProps {
  children: React.ReactNode;
}

/**
 * The bottom navigation is a mobile style navigation that displays an aditional menu
 * fixed on the bottom of the screen. Should be used as a navigation for logged in members to complement
 * the main navigation.
 */
export const BottomMenu = ({ children }: BottomMenuProps) => {
  return <div className={styles.bottomMenu}>{children}</div>;
};
export default BottomMenu;
